import { StyledImg, StyledBlueButton, StyledGreenButton, StyledRedButton, ButtonGrid } from "./SignatureBanner.styles";
import BannerTeltec from "assets/bannerTeltec.png";
import BannerServiceDesk from "assets/bannerServiceDesk.png";
import BannerSoc from "assets/bannerSoc.png";
import BannerAgenda2030 from "assets/bannerAgenda2030.png";
import BannerComercial from "assets/bannerComercial.png";
import { ToggleInput } from "components/ToggleInput";

type SignatureBannerProps = {
  banner: string;
  setBanner: (banner: string) => void;
  customPhone: string;
  setCustomPhone: (phone: string) => void;
  showBanner?: boolean;
  showControls?: boolean;
};

export const SignatureBanner = ({
  banner,
  setBanner,
  customPhone,
  setCustomPhone,
  showBanner = true,
  showControls = true,
}: SignatureBannerProps) => {

  const handleChange = (event: any) => {
    setCustomPhone(event.target.value);
  };

  return (
    <span>
      {showBanner ? (
        <a
          href="https://teltecsolutions.com.br/quem-somos/"
          rel="noopener noreferrer"
        >
          <StyledImg
            src={banner}
            width="390pt"
            height="auto"
          />
        </a>
      ) : null}
      {showControls ? (
        <>
          <ButtonGrid data-no-copy="true">
            <StyledBlueButton onClick={() => setBanner(BannerTeltec)}>Banner Teltec</StyledBlueButton>
            <StyledGreenButton onClick={() => setBanner(BannerServiceDesk)}>Banner Service Desk</StyledGreenButton>
            <StyledRedButton onClick={() => setBanner(BannerSoc)}>Banner SOC</StyledRedButton>
            <StyledBlueButton onClick={() => setBanner(BannerComercial)}>Banner Comercial</StyledBlueButton>
            <StyledGreenButton onClick={() => setBanner(BannerAgenda2030)}>Banner Agenda 2030</StyledGreenButton>
          </ButtonGrid>
          <div data-no-copy="true">
            <ToggleInput type={"tel"} placeholder={"Digite o número do telefone"} value={customPhone} onChange={handleChange} />
          </div>
        </>
      ) : null}
    </span>
  );
};
